import { ShieldCheck, FileSearch, BellRing, Gift, Eye, Lock, Wand2, Target, Filter, Globe2, Layers, BadgeEuro } from "lucide-react";

const CANDIDATE = [
  { icon: ShieldCheck, title: "Totalmente grátis", desc: "Procurar, candidatar-se e usar a IA de análise de CV não custa nada." },
  { icon: Lock, title: "CV privado por omissão", desc: "O PDF só é acessível às empresas a que te candidatas. Apagas quando quiseres (RGPD)." },
  { icon: FileSearch, title: "Análise de CV com IA", desc: "Competências detetadas, pontos fortes, palavras-chave em falta e sugestões concretas." },
  { icon: Eye, title: "Transparência total", desc: "Salário, regime e local visíveis na vaga. Estado da candidatura sempre atualizado." },
  { icon: BellRing, title: "Alertas de vagas", desc: "Define distrito, categoria e palavra-chave e são as vagas a encontrarem-te." },
  { icon: Gift, title: "Convida e ganha premium", desc: "3 amigos registados = 30 dias de IA ilimitada e badge de perfil." },
];

const COMPANY = [
  { icon: Wand2, title: "Anúncio escrito pela IA", desc: "Escreves três palavras-chave e sai um anúncio profissional: título, descrição e requisitos." },
  { icon: Target, title: "Match score por candidato", desc: "Pontuação 0-100 e resumo automático. Triagem em massa numa só ação." },
  { icon: BadgeEuro, title: "Publicar é grátis", desc: "Pagas só destaque quando precisas de velocidade. Sem mensalidades." },
  { icon: Layers, title: "Packs com desconto", desc: "Créditos de destaque em carteira, aplicados a qualquer vaga com um clique." },
  { icon: Globe2, title: "Página pública de empresa", desc: "Perfil indexável no Google com todas as vagas ativas e a tua marca." },
  { icon: Filter, title: "Mural com curadoria", desc: "Moderação humana de todas as vagas: menos ruído, mais candidaturas relevantes." },
];

const Column = ({ eyebrow, title, items, tone, testid }) => (
  <div data-testid={testid}>
    <p className={`text-xs uppercase tracking-[0.2em] font-bold mb-3 ${tone === "amber" ? "text-amber-600" : "text-sky-600"}`}>{eyebrow}</p>
    <h3 className="font-heading font-black tracking-tighter text-2xl text-slate-900">{title}</h3>
    <div className="mt-7 flex flex-col gap-3">
      {items.map((b) => (
        <div key={b.title} className="group flex items-start gap-4 bg-white rounded-2xl border border-black/5 p-5 hover:shadow-md hover:-translate-y-0.5 transition-transform">
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${tone === "amber" ? "bg-amber-50" : "bg-sky-50"}`}>
            <b.icon className={`w-5 h-5 ${tone === "amber" ? "text-amber-600" : "text-sky-600"}`} strokeWidth={1.75} />
          </div>
          <div>
            <p className="font-heading font-bold tracking-tight text-[15px] text-slate-900">{b.title}</p>
            <p className="text-sm text-slate-600 mt-1 leading-relaxed">{b.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const Benefits = () => (
  <section id="vantagens" className="bg-white border-y border-black/5 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20">
      <div className="max-w-2xl">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-3">Vantagens</p>
        <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl text-slate-900">
          Porque é diferente de um classificado qualquer
        </h2>
        <p className="text-slate-600 mt-4">
          Fizemos escolhas: grátis para quem procura, simples para quem contrata, e inteligência artificial
          onde ela poupa tempo de verdade.
        </p>
      </div>
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 mt-12">
        <Column eyebrow="Para candidatos" title="Encontra trabalho sem fricção" items={CANDIDATE} tone="amber" testid="benefits-candidatos" />
        <Column eyebrow="Para empresas" title="Contrata mais rápido, gasta menos" items={COMPANY} tone="sky" testid="benefits-empresas" />
      </div>
    </div>
  </section>
);
